import { usePreload } from '../../providers/PreloadProvider';
export const usePropertyGroups = () => {
  const store = usePreload();
  return store.propertyGroups;
};